// @ts-nocheck
/* eslint-disable */ /* NOTE: Auto-generated. Run `yarn build-icons` instead of editing. */ import { ReactComponent as JobExtended } from '../../../../../ui-v3/src/assets/icons/extended/entities/job.svg?react';
import { createIcons } from '../../Icon';
const JobIcon = /* @__PURE__ */ createIcons('Job', {
    extended: JobExtended
});
JobIcon.supportedTypes = [
    'extended'
];
JobIcon.category = 'entities';
export default JobIcon;
